export const delete_SplitButton = "qtd";
export const flagUnflag_SplitButton = "rtd";
export const junk_SplitButton = "std";
export const newMessage_SplitButton = "ttd";
export const respond_SplitButton = "utd";
export default {delete_SplitButton,flagUnflag_SplitButton,junk_SplitButton,newMessage_SplitButton,respond_SplitButton};